import type {PointAddress, SuggestObject} from '@yandex-delivery/api/model/suggest'
import type {Optional} from '@yandex-delivery/types'

function getAddressName(suggestObject: Optional<SuggestObject>) {
  return suggestObject?.title.text || suggestObject?.text || ''
}

export function fromSuggestToPointAddress(suggestObject: Optional<SuggestObject>): PointAddress {
  // В Suggest подмешаны сохраненные пользователем адреса. Для таких адресов актуальный адрес хранится в subtitle.text
  const fullName = suggestObject?.isSavedAddress ? suggestObject?.subtitle.text || '' : getAddressName(suggestObject)

  return {
    coordinates: suggestObject?.position,
    building: suggestObject?.house || '',
    city: suggestObject?.city || '',
    comment: suggestObject?.comment,
    country: suggestObject?.country,
    doorCode: suggestObject?.doorPhoneNumber || '',
    flat: suggestObject?.quartersNumber || '',
    floor: suggestObject?.floorNumber || '',
    porch: suggestObject?.porchnumber || '',
    shortName: suggestObject?.title.text || '',
    street: suggestObject?.street,
    uri: suggestObject?.uri,
    log: suggestObject?.log,
    fullName,
  }
}
